import axiosInstance from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const getLeavesApi = async () => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/leave-employees`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getHistoryLeavesApi = async (payload: any) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/leave-employee-histories/${payload}`,
      payload
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const uploadCTAllowanceApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/upload-ct-allowances`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLeaveReportApi = async (payload: any) => {
  console.log("DATE", payload);

  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/leaves/?startdate=${payload.startdate}&enddate=${payload.enddate}`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const approvalLeaveApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/approve-leaves-single/${payload.id}`,
      { status: payload.status, rejectedNotes: payload.rejectedNotes }
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const approveLeaveAllApi = async () => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/approve-all-leaves`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
